import type { ReactElement } from "react";

import { Stack } from "@similarweb/ui-components/foundations";

import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type UISignal from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignal";

import SignalsSegmentedSignalData from "./SignalsSegmentedSignalData";
import SignalsSegmentedSignalType from "./SignalsSegmentedSignalType";

type Props = {
    uiSignal: Readonly<UISignal<SignalFilters>>;
};

const SignalsSegmentedName = ({ uiSignal }: Props): ReactElement => {
    const { nameSegments, selectionTooltipLabels } = uiSignal;

    return (
        <Stack gap="6px">
            <SignalsSegmentedSignalType
                signalType={nameSegments.signalType}
                selectionOverflowOn={nameSegments.selectionOverflowOn}
                selectionTooltipLabels={selectionTooltipLabels}
            />
            <SignalsSegmentedSignalData
                signalData={nameSegments.signalData}
                selectionOverflowOn={nameSegments.selectionOverflowOn}
                selectionTooltipLabels={selectionTooltipLabels}
            />
        </Stack>
    );
};

export default SignalsSegmentedName;
